<template>
  <div :style="{ width: '100%', height: '100%', position: 'relative' }">
    <BackArrow v-show="showBackArrow" @click.native="backToDefaultView"></BackArrow>
    <NoData v-show="isNoData"></NoData>
    <div ref="container" :style="{ width: '100%', height: '100%' }"></div>
    <ChartLegendSwtich
      :legend-default-status="isShowLegendDefault"
      @switchStatus="handleShowOrHiddenLegend"
    ></ChartLegendSwtich>
  </div>
</template>

<script>
import {
  getChartBase64,
  copyObjectOrArray,
  resizeChart,
  swtichChartShowDetail,
  handleOriginData,
  getEveryYearDetailInfoFromContrastData,
  getEveryYearDetailInfoFromSituationData,
} from "@/utils/chartMethods"
import * as echarts from "echarts"
import getOption from "./option"
import color from "./color"
import NoData from "@/components/NoData"
import ChartLegendSwtich from "@/components/ChartLegendSwtich"
import BackArrow from "../BackArrow"
export default {
  props: {
    mode: {
      type: String,
      default: "v",
    },
    // scale: {
    //   type: Object,
    //   require: true,
    // },
    barTitle: {
      type: String,
      require: true,
    },
    barLabelDegree: {
      type: Number,
      default: 0,
    },
    barData: {
      type: Array,
      default: () => [],
    },
    barMode: {
      type: String,
      default: "bar-common",
    },
    areaOpacity: {
      type: Number,
      default: 0.8,
    },
    isShowLegendDefault: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NoData,
    ChartLegendSwtich,
    BackArrow,
  },
  watch: {
    barData: {
      handler(newData) {
        if (!this.option) return
        //初始化
        this.subcategories.length = 0
        //隐藏返回箭头
        this.showBackArrow = false

        this.setChart(newData)
      },
      //立即监听（初始化）
      immediate: true,
      //深度监听
      deep: true,
    },
  },
  computed: {
    isNoData: function () {
      return this.barData.length === 0
        ? true
        : Object.keys(this.barData[0].data).length === 0 &&
            Object.keys(this.barData[1].data).length === 0
    },
  },
  data() {
    return {
      bar: null,
      value: null,
      category: null,
      option: null, //配置项
      processedSeries: null,
      //子分类数据，用于坐标轴切换为子分类时
      processedSubCategorysData: null,
      //年份数据，默认shuju
      yearCategorysData: null,
      isShowLegend: this.isShowLegendDefault,
      showBackArrow: false,
      subCategoryDataFlag: false,
      subcategories: [],
    }
  },
  mounted() {
    //初始化bar
    this.init()
  },
  methods: {
    init() {
      this.bar = echarts.init(this.$refs["container"])
      //获取option对象，防止同种类各图相互影响
      this.option = getOption()

      this.setChart(this.barData)

      //初始化图表事件
      this.bar.on("click", (params) => {
        swtichChartShowDetail(
          {
            chart: this.bar,
            option: this.option,
            processedSubCategorysData: this.processedSubCategorysData,
            xAxisData: this.processedSubCategorysData.subCategories,
          },
          params
        )

        // 显示返回箭头
        this.showBackArrow = true
      })
      //图表自适应
      resizeChart(this.bar)
    },
    setChart(data) {
      //判断是信息对比页面
      data[0] && (this.subCategoryDataFlag = Boolean(data[0].subCategoryData))
      //处理折线图数据
      const { xAxisLabels, legends, subcategoryInfoList } = handleOriginData(data)
      this.subcategories = subcategoryInfoList
      //根据是不是信息对比还是态势处理得到根据年份的子分类详细数据
      if (this.subCategoryDataFlag) {
        this.processedSubCategorysData = getEveryYearDetailInfoFromContrastData(data, xAxisLabels)
      } else {
        this.processedSubCategorysData = getEveryYearDetailInfoFromSituationData(
          data,
          legends,
          xAxisLabels
        )
      }
      //循环处理设置series
      this.processedSeries = this.getProcessedSeries(data, legends, xAxisLabels)
      //设置option对象的属性，对图表进行参数设置
      this.setOptionProperty(xAxisLabels, legends)
      this.bar.setOption(this.option, true)
    },
    getProcessedSeries(chartData, legends, xAxisLabels) {
      const processedSeries = chartData.map(({ name, data }, index) => {
        const serie = { name, type: "bar", data: [] }
        xAxisLabels.forEach((category) => {
          if (data && data[category]) serie.data.push(data[category])
          else serie.data.push(0)
        })
        return this.setSerieProperty(serie, legends, index)
      })
      //保存年数据，用于数据维度的切换和返回
      this.yearCategorysData = {
        xAxisLabels,
        series: copyObjectOrArray(processedSeries),
      }
      return processedSeries
    },

    setSerieProperty(serie, legends, index) {
      if (this.barMode === "bar-common") {
        serie.itemStyle = {
          opacity: this.areaOpacity,
          color: color.commonColor[legends.indexOf(index)],
        }
      } else {
        serie.itemStyle = {
          opacity: this.areaOpacity,
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            color.gradiantColor[legends.indexOf(index)]
          ),
        }
      }
      return serie
    },
    setOptionProperty(xAxisLabels, legends) {
      if (this.barTitle) this.option.title.text = this.barTitle
      //控制是否显示图例
      this.option.legend.show = this.isShowLegend
      if (this.isShowLegendDefault) this.option.legend.textStyle.fontSize = "12px"
      //整理serie
      this.option.legend.data = legends
      if (this.barMode === "bar-common") {
        this.option.legend.color = color.commonColor
      }
      //设置x和y轴
      this.value = {
        type: "value",
        minInterval: 1, //不允许出现小数
        boundaryGap: [0, 0.01],
        splitLine: {
          lineStyle: {
            // 使用深浅的间隔色
            color: ["#c0c0c0"],
          },
        },
      }
      this.category = {
        type: "category",
        data: xAxisLabels,
      }
      if (this.mode === "h") {
        this.option.xAxis = { ...this.option.xAxis, ...this.value }
        this.option.yAxis = { ...this.option.yAxis, ...this.category }

        // 给显示值的坐标轴添加单位
        this.barData[0] &&
          this.barData[0].unit &&
          (this.option.xAxis.name = `单位(${this.barData[0].unit})`)
        this.option.dataZoom[1].yAxisIndex = 0
      } else {
        this.option.yAxis = { ...this.option.yAxis, ...this.value }
        this.option.xAxis = { ...this.option.xAxis, ...this.category }

        // 给显示值的坐标轴添加单位
        this.barData[0] &&
          this.barData[0].unit &&
          (this.option.yAxis.name = `单位(${this.barData[0].unit})`)
        this.option.dataZoom[1].xAxisIndex = 0
      }
      //设置x轴label标签旋转角度
      if (this.barLabelDegree) {
        this.option.xAxis.axisLabel.rotate = this.barLabelDegree * -1
        // this.option.yAxis.axisLabel.rotate = this.barLabelDegree * -1
      }
      //设置series
      this.option.series = this.processedSeries
    },
    handleShowOrHiddenLegend(flag) {
      this.isShowLegend = flag
      //控制是否显示图例
      this.option.legend.show = this.isShowLegend
      this.bar.setOption(this.option)
    },
    handleSaveImage() {
      return {
        chart_base64: getChartBase64(this.bar),
        year_start: this.yearCategorysData.xAxisLabels[0],
        year_end: this.yearCategorysData.xAxisLabels[this.yearCategorysData.xAxisLabels.length - 1],
        subcategories: this.subcategories,
      }
    },
    backToDefaultView() {
      this.option.xAxis.data = this.yearCategorysData.xAxisLabels
      this.option.series = copyObjectOrArray(this.yearCategorysData.series)
      this.bar.setOption(this.option)
      // //设置切换到的table日期，同于数据过滤
      // this.$emit("updateTableDataDate", { name: this.barTitle, date: "" })
      this.showBackArrow = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
